/* GLOBALS $ */
export default [
  'webskedService',
  'thirdPartyIntegrationService',
  'fnService',
  WebskedPitchesController,
]

const modalSize = [600, 580]

function WebskedPitchesController(
  webskedService,
  thirdPartyIntegrationService,
  fnService
) {
  this.$onInit = () => {
    this.story = this.storyObj
    fetchPitches()
  }

  this.hasStoryId = () => !!this.storyObj._id

  this.openWebsked = () => {
    window.open(`/websked/#/story/${this.story._id}`, `_blank`)
  }

  this.newPitch = (type) => {
    thirdPartyIntegrationService(
      `websked/#/pitch-form?storyID=${this.story._id}&type=${type}`,
      ['esc'],
      modalSize
    )
      .then((data) => fetchPitches())
      .catch(console.warn)
  }

  const fetchPitches = () => {
    // TODO Get this from the inital load settings....
    if (window.org_settings.disableWebskedIntegration || !this.story._id) {
      return
    }
    webskedService
      .getWebskedStory()
      .then((wss) => {
        this.platformPitches = fnService.at('data.pitches', [])(wss)
        this.publicationPitches = fnService.at('data.publicationPitches', [])(
          wss
        )
      })
      .catch(console.warn)
  }
}
